import { COLORS } from '@btime/constants'
import { compose, find, prop, propEq } from 'ramda'
import React, { useEffect } from 'react'

import { Text } from '../../../../components/presentation/Text'
import { URL_BTIME } from '../../../../utils/constants/urls'
import { useNavigation } from '../../../../utils/contexts/NavigationContext'
import { useQrcode } from '../../_load/QrcodeLoader'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import Link from '../../../../components/actions/Link'
import { useLinkTreeItemsWithFormattedUrls } from './_load/LinkTreeItemsLoader'
import Loading from '../../../../components/helpers/Loading'
import Panel from '../../../../components/structure/Panel'
import { setLocalStorageItem } from '../../../../utils/helpers/localStorage'
import { useAsset } from '../../_load/AssetLoader'

const Item = ({ icon, label, isDefault, url, ...props }) => {
  const asset = useAsset()

  const setLocalStorageAndRedirect = () => {
    setLocalStorageItem('asset', { asset })
  }

  const redirect = () => {
    setLocalStorageAndRedirect()
    window.open(url, '_blank')
  }

  return (
    <FlexCol>
      <Link {...props} onClick={redirect}>
        <Panel noMargin>
          <FlexGrid justify="flex-start" gutter={0.5}>
            {icon && <Icon name={icon} size="1.2rem" />}
            <Text bold color={COLORS.dark3}>
              {label}
            </Text>
          </FlexGrid>
        </Panel>
      </Link>
    </FlexCol>
  )
}

const LinkTreeMenu = () => {
  const asset = useAsset()
  const qrcode = useQrcode()
  const entityId = qrcode?.data?.id
  const navigate = useNavigation()
  const items = useLinkTreeItemsWithFormattedUrls()
  const redirectTo = compose(prop('url'), find(prop('isDefault')))(items)
  const showIcon = items.some(item => !!item.icon)

  useEffect(() => {
    if (redirectTo) window.location.assign(redirectTo)
  }, [])

  if (!!redirectTo) return <Loading />

  return (
    <FlexGrid direction="column" align="stretch" justify="flex-start" gutter={0.3}>
      {!!entityId &&
        items.filter(propEq('enabled', true)).map(item => {
          const isPublicHistory = !!item?.configuration?.isPublicHistory
          const entityType = asset ? 'asset' : 'place'
          return (
            <Item
              key={item.id}
              label={item.label}
              icon={item.icon}
              isDefault={item.isDefault}
              url={
                isPublicHistory
                  ? `http://${window.location.host}/public/history/${item.token}/${entityType}/${entityId}`
                  : item.url
              }
            />
          )
        })}
      <Item
        label="Escanear novo QR Code"
        icon={showIcon && 'RiQrCodeLine'}
        onClick={() => navigate(`/qrcodes/${qrcode.id}/scan`)}
      />
      <Item label="Saiba mais sobre a Btime" icon={showIcon && 'BsBootstrap'} href={URL_BTIME} />
    </FlexGrid>
  )
}

export default LinkTreeMenu
